import ProcessList from './ProcessList'

const DraftList = () => {
    return <ProcessList endpoint={'Processes/UsersDrafts/'} process={"ongoing"} />
}

export default DraftList